(function(){
  'use strict';
  function init(root){
    if(!root||root.dataset.pcReady)return;root.dataset.pcReady='1';
    var vp=root.querySelector('.snr-pc__vp'),t=root.querySelector('.snr-pc__track'),set=root.querySelector('.snr-pc__set');
    if(!vp||!t||!set||t.classList.contains('is-static'))return;
    function dur(){var px=parseFloat(getComputedStyle(t).getPropertyValue('--snr-pc-speed'))||35;var w=set.getBoundingClientRect().width;if(w>0)t.style.setProperty('--snr-pc-dur',(w/px).toFixed(1)+'s');}
    dur();window.addEventListener('resize',dur);
    if('ResizeObserver' in window)new ResizeObserver(dur).observe(set);
    document.addEventListener('visibilitychange',function(){vp.classList.toggle('is-tab-hidden',document.hidden);});
  }
  function all(){document.querySelectorAll('[data-snr-pc]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('[data-snr-pc]');if(r)init(r);});
})();
